import { gql, useMutation } from '@apollo/client'
import { useNotification } from '@btime/react-messager'
import { useTranslation } from 'react-i18next'

import { generalClient } from '../../../../utils/apollo/api'

const MUTATION = gql`
  mutation RemoveLinkTreeItem($id: [Int]) {
    removeLinkTreeItem(id: $id)
  }
`

export const useRemoveLinkTreeItem = () => {
  const [request, state] = useMutation(MUTATION, {
    client: generalClient
  })
  const t = useTranslation('common')
  const notify = useNotification()

  const handleRequest = id => {
    if (!id) return
    return request({ variables: { id } }).then(resp => {
      if (resp.errors) notify.error({ title: t('errorDelete') })
    })
  }

  return [handleRequest, state]
}
